import React, { useMemo } from 'react';
import { Card, CardBody, Col, Row } from 'react-bootstrap';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { TableResponsive } from '../../../components/common/TableResponsive';
import {
    useCallLogs,
    CallLogsHeader,
    getCallLogsColumns
} from './CallLogs/index';
import './EnquiryList/EnquiryList.css';

const CallLogs = () => {
    const {
        filteredLogs,
        isLoading,
        selectedDate,
        setSelectedDate,
        todayFormatted,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        selectedStaff,
        setSelectedStaff,
        staffList,
        selectedDistrict,
        setSelectedDistrict,
        districtList,
        stats,
        handleReport
    } = useCallLogs();

    const columns = useMemo(
        () => getCallLogsColumns({ handleReport }),
        [handleReport]
    );

    return (
        <>
            <BreadCrumb title="Call Logs" prevPage="Enquiry" prevPath="/enquiry" />
            <Row>
                <Col xs={12}>
                    <Card className="border-0 shadow-sm">
                        {/* Header: Date picker, staff, district filter, search & stats count */}
                        <CallLogsHeader
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                            todayFormatted={todayFormatted}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            statusFilter={statusFilter}
                            setStatusFilter={setStatusFilter}
                            selectedStaff={selectedStaff}
                            setSelectedStaff={setSelectedStaff}
                            staffList={staffList}
                            selectedDistrict={selectedDistrict}
                            setSelectedDistrict={setSelectedDistrict}
                            districtList={districtList}
                            stats={stats}
                        />

                        {/* Table Responsive Body */}
                        <CardBody className="p-0 p-md-3">
                            <TableResponsive
                                isLoading={isLoading}
                                columns={columns}
                                data={filteredLogs}
                                noRecord="No Call Logs Found for the Selected Filter"
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default CallLogs;
